import React from 'react';
import {Alert} from "@mui/material";

function AlertBox({type, message}) {
    const getAlert = () => {
        switch (type) {
            case 'success':
                return <Alert severity="success">{message}</Alert>;
            case 'error':
                return <Alert severity="error">{message}</Alert>;
            case 'warning':
                return <Alert severity="warning">{message}</Alert>;
            default:
                return <Alert severity="info">{message}</Alert>;
        }
    }

    return (
       getAlert(type)
    );
}

export default AlertBox;